import { render, staticRenderFns } from "./WidgetLoader.vue?vue&type=template&id=242a115e&scoped=true&"
import script from "./WidgetLoader.vue?vue&type=script&lang=js&"
export * from "./WidgetLoader.vue?vue&type=script&lang=js&"
import style0 from "./WidgetLoader.vue?vue&type=style&index=0&id=242a115e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.1_@vue+compiler-sfc@3.5.29_babel-core@7.0.0-bridge.0_@babel+core@7.24._f07fc21c0eeec7f6e04fb4ae2769cbbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a115e",
  null
  
)

export default component.exports